import axios from 'axios'

// API Environment URLs
const API_URLS = {
  dev: 'https://5il01eevh8.execute-api.us-east-1.amazonaws.com/dev',
  stage: 'https://gd0gvy4z3e.execute-api.us-east-1.amazonaws.com/stage',
  // prod: 'https://ayqttc20p6.execute-api.us-east-1.amazonaws.com/prod',
  prod: 'https://api.vasionidp.com',
}

// Current environment
// const CURRENT_ENV = 'dev'
// const CURRENT_ENV = 'stage'
const CURRENT_ENV = 'prod'

//

// Base configuration for all API clients
const baseConfig = {
  baseURL: API_URLS[CURRENT_ENV],
  timeout: 10000000,
}

// Factory function to create axios instances with different content types
const createApiClient = (contentType) => {
  const client = axios.create({
    ...baseConfig,
    headers: {
      'Content-Type': contentType,
    },
  })

  // Add request interceptor to attach token
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('AccessToken')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Add response interceptor to handle errors globally
  const loginEndpoint = '/auth/login'
  const mfaEndpoint = '/auth/verify-mfa'

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const url = error.config?.url
      if (error.response?.status === 401 && url !== loginEndpoint && url !== mfaEndpoint) {
        localStorage.removeItem('AccessToken')
        localStorage.removeItem('user')
      }
      return Promise.reject(error)
    }
  )

  return client
}

// Create API clients with different content types
const apiClient = createApiClient('application/json')
const apiClientMultipart = createApiClient('multipart/form-data')

// Generic HTTP methods
export const get = (url, params = {}) => {
  return apiClient.get(url, { params })
}

// Binary data method - returns blob response
export const getBinary = async (url, params = {}) => {
  const client = axios.create({
    ...baseConfig,
    responseType: 'blob', // Important: tells axios to handle binary data
  })

  // Add request interceptor to attach token (same as regular client)
  client.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('AccessToken')
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  // Add response interceptor (same as regular client)
  const loginEndpoint = '/auth/login'
  const mfaEndpoint = '/auth/verify-mfa'

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      const url = error.config?.url
      if (error.response?.status === 401 && url !== loginEndpoint && url !== mfaEndpoint) {
        localStorage.removeItem('AccessToken')
        localStorage.removeItem('user')
      }
      return Promise.reject(error)
    }
  )

  return client.get(url, { params })
}

export const post = (url, data = {}) => {
  return apiClient.post(url, data)
}

export const postImage = (url, data = {}) => {
  return apiClientMultipart.post(url, data)
}

export const put = (url, data = {}) => {
  return apiClient.put(url, data)
}

export const del = (url) => {
  return apiClient.delete(url)
}

// Specific API methods
export const deleteJob = (jobId) => {
  return del(`/v1/mx-jobs/${jobId}`)
}

export const putJobs = () => {}

export const getUserById = (id) => get(`/v1/users/${id}`)
export const updateUser = (id, data) => put(`/v1/users/${id}`, data)

export default apiClient
